























import Vue from 'vue';
import { Component, Model } from 'vue-property-decorator';
import { Base } from '@/components/common/base';
import { VHeaders, PaginationModel } from '@/models/pagedlistmodel';
import { callHistoryService } from '@/shared';
import { GetAllActivePhoneNumberResponse } from '@/Alynk.dtos';
import { FileHelper } from '@/helper/file.helper';

@Component({
    props: ['methodName', 'progress'],
    directives: {
    },
    components: {
        Grid: () => import('@/components/common/app.grid.vue'),
    },
    computed: {
        methodtoCall: {
            get() {
                return this.$props.methodName;
            },
        },
    },
        data() {
    return {
        phoneNumbers: []  // or whatever default value is appropriate
    };
  },
})
export default class TwilioPhoneNumbersPage extends Base {
    public storeId: number = 0;
    public pagination = new PaginationModel('createdAt');
    public phoneNumbers: GetAllActivePhoneNumberResponse;
    public headers: VHeaders[] = [];
    public loading: boolean = false;

    public mounted() {
        // activating tab
        this.$root.$emit('sidebar.layout.vue', 'twiliophoneNumbers');
        // Toolbar
        this.storeId = this.userSession.storeId;
        this.updateToolBar();
        this.$watch('methodtoCall', (newVal, oldVal) => {
            if (newVal) {
                this.callMethod(newVal);
            }
        });
        this.setHeaders();
        this.getPhoneNumbers();
    }

    public callMethod(methodName): void {
        if (methodName === 'downloadCsv') {
            this.downLoadCsv();
        }
        this.resetMethodName(methodName);
    }

    public resetMethodName(methodName): void {
        if (methodName !== '') {
            this.$emit('resetMethodName', methodName);
        }
    }

    public updateToolBar(): void {
        const buttons: any = [];
        buttons.push({
            id: '0',
            type: 'button',
            title: this.$t('vendorListPage.titleAddVendor'),
            disabled: false,
            visible: true,
            class: 'btn',
            label: "Download CSV",
            click: 'downloadCsv',
            icon: 'fa fa-download',
            requestProgress: true
        });
        this.$emit('updateToolBar', buttons);
    }

    public beforeDestroy() {
        const buttons = [];
        this.$emit('updateToolBar', buttons);
    }

    public async downLoadCsv(): Promise<void> {
        try {
            this.showAlert(true, 'Request Has been initiated for downloading Csv, Please Wait.');
            const response = await callHistoryService.downloadActivePhoneNumbers();
            const bytes = FileHelper.base64ToArrayBuffer(response);
            FileHelper.downloadBytes(bytes, '', 'TwilioActiveNumbers.csv');

            this.showAlert(true, 'File has been downloaded');
        } finally {
        }
    }

    public setHeaders() {
        this.headers = [
            {
                text: 'Phone Number',
                value: 'phoneNumber',
                align: 'left',
                sortable: false,
            },
            {
                text: 'Friendly Name',
                value: 'friendlyName',
                align: 'left',
                sortable: false,
            },
            {
                text: 'Created Date',
                value: 'createdDate',
                align: 'left',
                sortable: true,
            },
            {
                text: 'Status',
                value: 'status',
                align: 'left',
                sortable: false,
            }
        ];
    }

    public async getPhoneNumbers() {
        try {
            this.loading = true;
            const response = await callHistoryService.getAllPhoneNumbers();
            this.phoneNumbers = response;
        } finally {
            this.loading = false;
        }
    }

    public updateCallPaging(paging: any) {
        this.pagination = paging;
    }

}
